import React from 'react';

// Custom <Br /> component
const Br = () => {
  return (
    <div style={{ height: '1.5vh' }}></div>
  );
};

export default Br;